module.exports = __webpack_public_path__ + "static/bighat-cae23609284186f5e71bf1a4fbcb94f2.jpg";